import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Title
  } from 'chart.js';
  
  export function registerChartComponents() {
    ChartJS.register(
      LinearScale,
      CategoryScale,
      BarElement,
      PointElement,
      LineElement,
      Legend,
      Tooltip,
      LineController,
      BarController,
      Title
    );
  }